import { createFileRoute, Outlet } from "@tanstack/react-router";
import { COMING_SOON_PATH, requireOneDeliveryAccess } from "~/components/one-delivery/access";

export const Route = createFileRoute("/one-delivery")({
	beforeLoad: async ({ context, location }) => {
		if (location.pathname !== COMING_SOON_PATH) await requireOneDeliveryAccess(context.relayEnvironment);
	},
	component: Outlet,
});
